import React, { useEffect, useRef } from "react";

import Icon from "../icons/icon";

import styles from "./loader.module.css";

const Loader = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const x = canvas.width / 2;
    const y = canvas.height / 2;
    const radius = 100;
    const startAngle = 0;
    let endAngle = 0;
    let counterClockwise = false;
    let animation;

    const drawCircle = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.lineWidth = 1;
      ctx.strokeStyle = "white";
      ctx.beginPath();
      ctx.arc(x, y, radius, startAngle, endAngle, counterClockwise);
      ctx.stroke();

      endAngle += Math.PI / 35;
      if (endAngle > 2 * Math.PI) {
        cancelAnimationFrame(animation);
        return;
      }

      animation = requestAnimationFrame(drawCircle);
    };

    animation = requestAnimationFrame(drawCircle);

    return () => {
      cancelAnimationFrame(animation);
    };
  }, []);

  useEffect(() => {
    const canvas = document.getElementById("myCanvas2");
    const ctx = canvas.getContext("2d");

    const x = canvas.width / 2;
    const y = canvas.height / 2;
    const radius = 100;
    const startAngle = 0;
    const endAngle = 2 * Math.PI;

    ctx.lineWidth = 1;
    ctx.strokeStyle = "rgba(255, 255, 255, 0.14)";
    ctx.beginPath();
    ctx.arc(x, y, radius, startAngle, endAngle);
    ctx.stroke();
  }, []);

  return (
    <div className={styles.loader} style={{ height: window.innerHeight }}>
      <div className={styles.circle}>
        <div className={styles.circleBox}>
          <canvas
            className={styles.circleWrapper}
            id="myCanvas2"
            width="225"
            height="225"
          ></canvas>

          <canvas
            className={styles.circleWrapper}
            id="myCanvas"
            width="225"
            height="225"
            ref={canvasRef}
          ></canvas>
        </div>

        <Icon type="Logo" />
      </div>
    </div>
  );
};

export default Loader;
